import { render } from "./Warning.vue?vue&type=template&id=3d36489e&scoped=true"
import script from "./Warning.vue?vue&type=script&lang=js"
export * from "./Warning.vue?vue&type=script&lang=js"

import "./Warning.vue?vue&type=style&index=0&id=3d36489e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d36489e"]])

export default __exports__